import { render, staticRenderFns } from "./dialog-form.vue?vue&type=template&id=6350f2ce&scoped=true"
import script from "./dialog-form.vue?vue&type=script&lang=js"
export * from "./dialog-form.vue?vue&type=script&lang=js"
import style0 from "./dialog-form.vue?vue&type=style&index=0&id=6350f2ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6350f2ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6350f2ce')) {
      api.createRecord('6350f2ce', component.options)
    } else {
      api.reload('6350f2ce', component.options)
    }
    module.hot.accept("./dialog-form.vue?vue&type=template&id=6350f2ce&scoped=true", function () {
      api.rerender('6350f2ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-common/dialog-form.vue"
export default component.exports